/**
 * Gateway Login Bundle
 *
 * Minimal React bundle for the Privy login button on Blade gateway pages.
 * This is NOT a full SPA — it renders one login button that triggers the
 * Privy popup. On auth success, POSTs to the server and follows the redirect.
 *
 * WHY SEPARATE FROM app.js:
 * app.js wraps the entire Inertia app in PrivyProvider. Gateway pages are
 * standard Blade pages (not Inertia), so they need their own PrivyProvider.
 * This bundle is small and focused — just auth, nothing else.
 *
 * PATTERN:
 * Same as data-room-uploader.js — import shared-react-bootstrap, export
 * component to window, auto-mount on DOMContentLoaded.
 */

import './shared-react-bootstrap';
import GatewayLogin from './components/GatewayLogin';

const React = window.React;
const ReactDOM = window.ReactDOM;

// Auto-mount on DOMContentLoaded if mount point exists
document.addEventListener('DOMContentLoaded', function () {
    const container = document.getElementById('privy-gateway-mount');
    if (!container || !ReactDOM || !React) return;

    const root = ReactDOM.createRoot(container);
    root.render(
        React.createElement(GatewayLogin, {
            appId: container.dataset.privyAppId,
            gatewaySlug: container.dataset.gatewaySlug,
            csrfToken: container.dataset.csrfToken,
            authenticateUrl: container.dataset.authenticateUrl,
            resolveExistingUrl: container.dataset.resolveExistingUrl || null,
            signOutUrl: container.dataset.signOutUrl || null,
            invitationCode: container.dataset.invitationCode || null,
            roleType: container.dataset.roleType || null,
            supportEmail: container.dataset.supportEmail || null,
            orgName: container.dataset.orgName || null,
        })
    );
});
